const CustomerActionTypes = {
  SET_LOCATIONS: 'SET_LOCATIONS',
  ADD_LOCATION: 'ADD_LOCATION',
};

export default CustomerActionTypes;
